import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { AssessmentService } from '../service/assessment.service';

@Injectable({
    providedIn: 'root'
})
export class AssessmentValidators
{
    constructor(private assessmentService: AssessmentService) { }

    public validateAssessmentTypeNameUnique(control: UntypedFormControl, initialCategoryName: string): any
    {
        return new Promise(resolve =>
        {
            if (control !== null && initialCategoryName !== control.value)
            {
                this.assessmentService.existsAssessmentTypeName(control.value).subscribe({
                    next: (response) =>
                    {
                        if (response)
                        {
                            resolve({ nameExists: true });
                        }
                        else
                        {
                            resolve(null);
                        }
                    }
                });
            }
            else
            {
                resolve(null);
            }
        });
    }
}
